import useMedicalProfile from './useMedicalProfile';

export type UseIsFastenEnabledReturnValue = {
    isFastenEnabled: boolean;
    isLoading: boolean;
};

export const useIsFastenEnabled = (medicalProfileId: string): UseIsFastenEnabledReturnValue => {
    const { profile, isLoadingProfile } = useMedicalProfile({ medicalProfileId });

    return {
        isFastenEnabled: profile?.isFastenEnabled ?? false,
        isLoading: isLoadingProfile,
    };
};
